import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheck, KeyRound } from "lucide-react";

export default function ChangePassword() {
  const { user, setUser, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (next !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: current, new_password: next });
      setUser(data.user);
      toast.success("Password updated — welcome!");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not update password");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm" data-testid="change-password-screen">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-sky-50"><ShieldCheck className="h-6 w-6 text-sky-600" /></div>
        <h1 className="mt-4 font-heading text-2xl font-bold text-slate-900">Set your password</h1>
        <p className="mt-1 text-sm text-slate-500">You're signed in with a temporary password, {user?.name?.split(" ")[0] || "there"}. Please choose a new one to continue.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-sm font-semibold">Temporary password</Label>
            <Input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1 rounded-lg" autoComplete="current-password" required />
          </div>
          <div>
            <Label className="text-sm font-semibold">New password</Label>
            <Input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} className="mt-1 rounded-lg" placeholder="At least 8 characters" autoComplete="new-password" required />
          </div>
          <div>
            <Label className="text-sm font-semibold">Confirm new password</Label>
            <Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1 rounded-lg" autoComplete="new-password" required />
          </div>
          <Button data-testid="cp-submit" type="submit" disabled={busy} className="w-full rounded-lg bg-sky-600 hover:bg-sky-700">
            <KeyRound className="mr-1.5 h-4 w-4" /> {busy ? "Saving…" : "Save & continue"}
          </Button>
        </form>
        <button onClick={logout} data-testid="cp-logout" className="mt-4 w-full text-center text-xs text-slate-400 hover:text-slate-600">Sign out</button>
      </div>
    </div>
  );
}
